import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Game from "./pages/Game";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Game />} />
        {/* <Route path="/">
          <Route path="game" element={<Game />} />
        </Route> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
